import ToggleRadioButton from "../../../components/ToggleRadioButton/ToggleRadioButton";
import { translate } from "../../../utils/translator";
import { useParams } from "react-router-dom";
import "./PaymentOptionCard/PaymentOptionCard.css"

type Props = {
  isToggleEnabled: boolean,
  updateToggle: () => void,
  precautionLevel: string,
  isOnlyPrescription?: boolean,
  isCannabisCatalog?: boolean
  onTermsLinkClick?: () => void
  orange?: boolean
}

const TogglePrecaution: React.FC<Props> = ({ isToggleEnabled, updateToggle, precautionLevel, isOnlyPrescription,isCannabisCatalog, onTermsLinkClick, orange = false }) => {
  const { language } = useParams();
  const textColor = precautionLevel === "error" ? "var(--primary-danger)" : "var(--radiobutton-text-color)";

  return (
    <div className="toggle-precaution-container">
      <ToggleRadioButton
        id={precautionLevel === "error" ? "toggle-precaution-error" : "toggle-precaution"}
        isToggleEnabled={isToggleEnabled}
        updateToggle={updateToggle}
        orange={orange}
      />

      {isCannabisCatalog ? (
        isOnlyPrescription ? (
          <span className="toggle-precaution-text" style={{ color: textColor }}>
            {translate(language, "shipping", "TogglePrecaution/cannabis_pickup")}
          </span>
        ) : (
          <span className="toggle-precaution-text" style={{ color: textColor }}>
            {translate(language, "shipping", "TogglePrecaution/cannabis_delivery_prefix")}{' '}
            <a
              id="toggle-precaution-link"
              href="#"
              className="underline text-[#269C6E]"
              onClick={(e) => {
                e.preventDefault();
                onTermsLinkClick?.();
                const el = document.getElementById('selected-delivery-option-header') || document.getElementById('selected-delivery-option');
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
            >
              {translate(language, "shipping", "TogglePrecaution/terms_link")}
            </a>{' '}
            {translate(language, "shipping", "TogglePrecaution/cannabis_delivery_suffix")}
            <b> {translate(language, "shipping", "TogglePrecaution/cannabis_id_delivery")} </b>
          </span>
        )
      ) : (
        <span className="toggle-precaution-text" style={{ color: textColor }}>
          {translate(language, "shipping", "TogglePrecaution/default_prefix")}
          <b> {translate(language, "shipping", "TogglePrecaution/default_id_bold")} </b>
        </span>
      )}
    </div>
  )
}

export default TogglePrecaution  